import styled from 'styled-components';

const Button = styled.button`
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  font-size: 13px;
  font-family: 'SF Display Bold';
  background-color: #fff;
  ${({ filled, color, height, width, margin, disabled, alignSelf }) => `
		color: ${filled ? 'white' : color};
		border: ${filled ? 'none' : 'solid'};
		border-width: ${filled ? '0px' : '2px'};
		border-radius: ${height / 2}px;
		background-color: ${filled ? color : 'white'};
		border-color: ${color};
		width: ${width ? width : '100%'}px;
		height: ${height ? height : '100%'}px;
		margin: ${margin};
		align-self: ${alignSelf};

		${
      disabled &&
      `
	  		border: 1px solid #C1C1C1;
			color: #C1C1C1;
			background-color: white;
		`
    }
	`};
  box-sizing: border-box;
  transition: opacity 120ms ease, transform 120ms ease;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:active:not(:disabled) {
    transform: translateY(1px);
  }

  &:focus-visible {
    outline: 3px solid var(--lms-focus);
    outline-offset: 3px;
  }

  &:disabled {
    opacity: 0.72;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export default Button;
